<template>
  <ScrollingBox
    section-id="benefits"
    :section-title="sectionTitle"
    :section-description="sectionDescription"
    :data="benefits"
    :show-left-line="true"
    button-text="Apply to join"
  />
</template>

<script>
import ScrollingBox from '../shared/ScrollingBox/ScrollingBox.vue';

export default {
  components: { ScrollingBox },
  data() {
    return {
      sectionTitle: 'Why become a<br/> Proxify member?',
      sectionDescription:
        'Join 4000+ members landing remote roles at<br/>global companies with tailored career support.',
      benefits: [
        {
          illustration: '/images/home-page/benefits/puzzle.svg',
          title: 'Work with the best',
          titleMobile: 'Work with the best',
          description:
            'We’ll recommend you for jobs at trusted, global companies.',
        },
        {
          illustration: '/images/home-page/benefits/globe.svg',
          title: 'Work from anywhere',
          titleMobile: 'Work from anywhere',
          description:
            'All our roles and career support<br/>services are fully remote.',
        },
        {
          illustration: '/images/home-page/benefits/avatar.svg',
          title: 'Get expert coaching',
          titleMobile: 'Get expert coaching',
          description:
            'Our industry experts help you leverage<br/>your unique experience and skills.',
        },
        {
          illustration: '/images/home-page/benefits/money.svg',
          title: 'Payment support',
          titleMobile: 'Payment support',
          description:
            'Get paid on time, every time, in the<br/>currency of your choice.',
        },
      ],
    };
  },
};
</script>
